import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import Typekit from "react-typekit";
import Contact from "../components/Contact";
import Background from "../components/Background";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MenuClose from "../components/MenuClose";
import NavFooter from "../components/NavFooter";
import Media from "../components/Media";
import Panda from "../components/Panda";
import { observer, inject } from "mobx-react";
import "../styles/core.css";
const TemplateWrapper = ({ menu, children }) => (
  <div>
    <Helmet
      title="PandaGoat Media"
      meta={[
        {
          name: "description",
          content:
            "We are a digital collective that works together to deliver great products."
        },
        { itemprop: "name", content: "PandaGoat Media" },
        { name: "twitter:card", content: "summary" },
        { name: "twitter:title", content: "Panda Goat Media" },
        { name: "og:title", content: "Panda Goat Media" },
        { name: "og:url", content: "https://www.pandagoatmedia.com" },
        { name: "og:site_name", content: "Panda Goat Media" },
        { name: "og:type", content: "website" },
        { name: "twitter:site", content: "@pandagoatmedia ‏" },
        { name: "twitter:creator", content: "@pandagoatmedia ‏" }
      ]}
    />
    <Typekit kitId="mbr8ugc" />
    <div
      style={{
        position: "relative"
      }}
    >
      <Background />
      <NavFooter />
      <Header />
      {children()}
      <Footer />
      <Media />
      <Contact />
      <MenuClose />
    </div>
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default inject(({ store }) => ({
  menu: store.appStore.menu.open
}))(observer(TemplateWrapper));



// WEBPACK FOOTER //
// ./src/layouts/index.js